import { useNavigate, useParams } from "react-router-dom";
import PartnerLink from "../../components/PartnerLink";
import CompleteBox from "../../components/CompleteBox";
import PageFooter from "../../components/PageFooter";
import React from "react";
import * as S from "./styles";
import Logo from "../../assets/logo.png";

const Home = () => {
  const link = "https://www.monthler.kr";
  const title = "한달살러 신청서 페이지 홈입니다.";
  const text =
    '<p>안녕하세요. 한달살러 운영자 애나입니다.</p><p>한달살러는 국내해외의 <strong><u>다양한 여행지원 프로그램을 무료로 등록</u></strong>할 수 있으며, 이를 위해 <strong><u>파트너 신청이 필요</u></strong>합니다.</p><p>이미 많은 단체에서 파트너로 전환하여 프로그램을 등록중입니다. 한달살러 파트너가 되어 함께 프로그램 참가자를 모집하세요.</p><p><br></p><p><strong>⭕️ 무료 등록 기준</strong></p><ul><li>정부지원과 연계된 프로그램</li><li>팸투어, 서포터즈, 로컬프로젝트로</li><li>정부지원과 관계없으나 전액지원으로 진행하는 프로그램</li><li>유료 프로그램은 <a href="https://open.kakao.com/o/s17627Yf" rel="noopener noreferrer" target="_blank">1:1카톡문의</a></li></ul><p><br></p><p><strong>⭕️ 한달살러 파트너 좋은점 (간략 정리)</strong></p><ul><li>전용 관리자페이지에서 프로그램을 관리할 수 있습니다.</li><li>(1)프로그램 무한등록 (2)댓글관리 (3)신청서제작/관리를 할 수 있습니다.</li><li>개선점 제안시 반영될 수 있습니다.</li></ul><p><br></p><p><strong style="color: rgb(230, 0, 0);">▼ 파트너 계정 전환하는 방법</strong></p><p><strong>1. 구글플레이, 앱스토어에서 &lt;한달살러&gt;를 검색하신 후 앱을 다운로드해주세요.</strong></p><ul><li><a href="https://cnd1.short.gy/9Dq2rA" rel="noopener noreferrer" target="_blank">(링크) 구글플레이에서 앱 다운로드하기</a></li><li><a href="https://cnd1.short.gy/Obsg1e" rel="noopener noreferrer" target="_blank">(링크) 앱스토어에서 앱 다운로드하기</a></li></ul><p><strong>2. [이메일 회원가입]을 합니다.</strong></p><ul><li><u>꼭 이메일 회원가입으로 가입</u>되어야 합니다.</li><li>이메일 회원가입이 아닐시 재가입 요청을 할 수 있습니다.</li></ul><p class="ql-align-center"><img src="https://dev-www-monthler.s3.ap-northeast-2.amazonaws.com/form/810/1722675302785.uploaded_image" alt="한달살러이메일회원가입하는방법"></p><p class="ql-align-center"><br></p><p><br></p><p>* 이메일 회원가입을 완료했다면, 아래 신청서를 제출해주세요.</p><p>* 1~2일내에 관리자페이지에 대한 설명이 이메일로 전달됩니다.</p><p><strong style="color: rgb(11, 36, 251);">* 현재 보고 있는 신청서는 <u>프로그램별로 직접 쉽게</u> 만들 수 있습니다. (파트너에 한해 무료 제공)</strong></p><br><a href="https://monthler-form.monthler.kr/form/apply/hipartner">✅ 파트너 전환하기</a>';
  const name = "한달살러";
  const handleClick = () => {
    window.open(link, "_blank");
  };

  return (
    <div>
      <S.PartnerImageContainer>
        <S.PartnerImage image={Logo} onClick={handleClick} />
      </S.PartnerImageContainer>
      <CompleteBox completeTitle={title} completeText={text} />
      <PageFooter partnerName={name} />
    </div>
  );
};

export default Home;
